import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { Waves } from './Waves';
import { Seed } from './Seed';
export function Close() {
  return <section className="w-full bg-white" data-id="element-48" data-mp="1uy2w0t2pqz0m">
      <Waves to="#0F2D5C" data-id="element-49" data-mp="1ux1imhy860fq" />
      <div className="stage-smoke relative overflow-hidden text-white" data-id="element-50" data-mp="1v0fo3z26qpre">
        <p aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-6 select-none text-center font-poster text-[26vw] uppercase leading-none text-white/[0.06] lg:text-[270px]" data-id="element-51" data-mp="1pygj6kqsrksc">
          Sailing
        </p>
        <div className="relative mx-auto max-w-3xl px-5 pb-16 pt-10 text-center sm:pb-20" data-id="element-52" data-mp="1c7lihvqgc9zu">
          <Seed className="mx-auto h-16 w-16" data-id="element-53" data-mp="178qqq4aibb3l" />
          <h2 className="mt-5 font-display text-4xl leading-tight sm:text-6xl" data-id="element-54" data-mp="17a1s5xghc6rj">
            Stop letting the wind <span className="text-peach" data-id="element-55" data-mp="128chwk12zx4i">write your lesson plan.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-56" data-mp="xblzvr5purgg">
            Beginner lessons, boat handling, shore and theory, race training,
            junior camps, adult courses and full seasons. Six volumes and 131
            Lesson Cards, every one planned for light air, right air and wrong
            air.
          </p>

          <div className="mt-7" data-id="element-57" data-mp="3lf4l9m3cm6na">
            <Countdown size="sm" data-id="element-58" data-mp="3qg2bmlyii6zv" />
          </div>

          <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl bg-white px-5 py-4 text-left shadow-card" data-id="element-59" data-mp="3qgu0ldxlt6h6">
            <div data-id="element-60" data-mp="n04zw8kpcqzf">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-61" data-mp="myk82qprvm59">Complete package</span>
              <span className="text-[15px] font-semibold text-navy" data-id="element-62" data-mp="834aibpzh844">Sailing Lesson Ready, 6 volumes + 5 bonuses</span>
            </div>
            <div className="flex items-baseline gap-2.5" data-id="element-63" data-mp="czkx31hjbef3">
              <span className="text-[15px] text-navy-muted line-through" data-id="element-64" data-mp="2ssacvnjt2xq6">$90</span>
              <span className="font-display text-4xl leading-none text-navy" data-id="element-65" data-mp="2xrek48n66ldv">$27</span>
            </div>
          </div>

          <div className="mx-auto mt-5 max-w-lg" data-id="element-66" data-mp="147w6k92a4end">
            <CtaButton data-id="element-67" data-mp="14aqrs2t4a3hu">Yes, I want Sailing Lesson Ready for $27</CtaButton>
          </div>

          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-68" data-mp="zbxmuyrwbkta">
            {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-69" data-mp="pjrn32vejz3j">
                <span className="h-1.5 w-1.5 rounded-full bg-peach" data-id="element-70" data-mp="klzu05j0u6xr" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}